import React from 'react';
import { BudgetGame } from '@/components/games/budget/BudgetGame';
import { GameLayout } from '@/components/layout/GameLayout';

export default function BudgetGamePage() {
  return (
    <GameLayout
      title="Presupuesto Familiar"
      description="Aprende a crear y manejar un presupuesto familiar básico"
    >
      <BudgetGame />
    </GameLayout>
  );
}
